"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTheme = exports.ThemeSbaa = exports.ThemeIleo = exports.ThemeSem = exports.ThemeSieccao = exports.ThemeSepra = exports.ThemeSiaepQuestembert = exports.ThemeDerichebourg = exports.ThemeEauxSaumurValDeLoire = exports.ThemeEauDuMorbihan = exports.ThemeEau2Garonne = exports.ThemeSepig = exports.ThemeGpeau = exports.ThemeVilivia = exports.ThemeMartinique = exports.ThemeSe3r = exports.ThemeAccm = exports.ThemeCer = exports.ThemeSaurGuadeloupe = exports.ThemeSaur = exports.ThemeCgsp = exports.ThemeCiseReunion = exports.ThemeSaintAffo = exports.ThemeAtlanticeau = exports.ThemeGrandLac = exports.ThemeSaintMartin = exports.ThemeSudeau = exports.ThemeSateg = void 0;
var Theme_1 = require("./Theme");
var ThemeSateg = {
    name: 'sateg',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeSateg = ThemeSateg;
var ThemeSudeau = {
    name: 'sudeau',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeSudeau = ThemeSudeau;
var ThemeSaintMartin = {
    name: 'saint-martin',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeSaintMartin = ThemeSaintMartin;
var ThemeGrandLac = {
    name: 'grand-lac',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeGrandLac = ThemeGrandLac;
var ThemeAtlanticeau = {
    name: 'atlantic-eau',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeAtlanticeau = ThemeAtlanticeau;
var ThemeSaintAffo = {
    name: 'saint-affo',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeSaintAffo = ThemeSaintAffo;
var ThemeCiseReunion = {
    name: 'cise-reunion',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeCiseReunion = ThemeCiseReunion;
var ThemeCgsp = {
    name: 'cgsp',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeCgsp = ThemeCgsp;
var ThemeSaurGuadeloupe = {
    name: 'saur-guadeloupe',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeSaurGuadeloupe = ThemeSaurGuadeloupe;
var ThemeSaur = {
    name: 'saur',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.deepBlue,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.blue,
        activeColor: Theme_1.colors.blue
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeSaur = ThemeSaur;
var ThemeSem = {
    name: 'sem',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.blue,
    menuBackground: Theme_1.colors.SEM_blue,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.SEM_HighlightBlue,
        activeColor: Theme_1.colors.SEM_HighlightBlue
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    contracts: {
        primary: Theme_1.colors.SEM_blue,
        activeIcon: Theme_1.colors.purple
    },
    consumptions: {
        bars: Theme_1.colors.SEM_lightBlue
    },
    colors: {
        primary: Theme_1.colors.SEM_blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.SEM_blue,
        primaryDark: Theme_1.colors.SEM_blue,
        secondary: Theme_1.colors.SEM_green,
        secondaryLight: Theme_1.colors.SEM_greenLight
    }
};
exports.ThemeSem = ThemeSem;
var ThemeCer = {
    name: 'cer',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeCer = ThemeCer;
var ThemeAccm = {
    name: 'accm',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeAccm = ThemeAccm;
var ThemeSe3r = {
    name: 'se3r',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeSe3r = ThemeSe3r;
var ThemeMartinique = {
    name: 'saur-martinique',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeMartinique = ThemeMartinique;
var ThemeVilivia = {
    name: 'vilivia',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    contracts: {
        primary: Theme_1.colors.VILIVIA_GREEN,
        activeIcon: Theme_1.colors.VILIVIA_DARK_YELLOW
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    consumptions: {
        bars: Theme_1.colors.VILIVIA_GREEN_DARK
    },
    colors: {
        primary: Theme_1.colors.VILIVIA_DARK_YELLOW,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.VILIVIA_GREEN,
        primaryAccent: Theme_1.colors.VILIVIA_GREEN,
        primaryDark: Theme_1.colors.VILIVIA_GREEN,
        secondary: Theme_1.colors.VILIVIA_GREEN_LIGHT,
        secondaryLight: Theme_1.colors.VILIVIA_YELLOW_LIGHT
    }
};
exports.ThemeVilivia = ThemeVilivia;
var ThemeGpeau = {
    name: 'saur-gpeau',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    consumptions: {
        bars: Theme_1.colors.GPEAU_BLUE
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.GPEAU_ORANGE,
        secondaryLight: Theme_1.colors.GPEAU_LIGHT_ORANGE
    }
};
exports.ThemeGpeau = ThemeGpeau;
var ThemeSepig = {
    name: 'sepig',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeSepig = ThemeSepig;
var ThemeEau2Garonne = {
    name: 'eau-de-garonne',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.blue,
    menuBackground: Theme_1.colors.deepBlue,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.blue,
        activeColor: Theme_1.colors.blue
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.E2G_green,
        secondaryLight: Theme_1.colors.E2G_greenLight
    }
};
exports.ThemeEau2Garonne = ThemeEau2Garonne;
var ThemeEauDuMorbihan = {
    name: 'saur-eau-du-morbihan',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.EDM_blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.EDM_blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.EDM_lightBlue,
        primaryDark: Theme_1.colors.EDM_blue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeEauDuMorbihan = ThemeEauDuMorbihan;
var ThemeEauxSaumurValDeLoire = {
    name: 'eaux-saumur-val-de-loire',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.blue,
    menuBackground: Theme_1.colors.ESVDL_lightBlue,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.darkblue,
        activeColor: Theme_1.colors.blue
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.ESVDL_deepBlue,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.ESVDL_deepBlue,
        primaryDark: Theme_1.colors.ESVDL_lightBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeEauxSaumurValDeLoire = ThemeEauxSaumurValDeLoire;
var ThemeDerichebourg = {
    name: 'saur-derichebourg-aoi',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    colors: {
        primary: Theme_1.colors.blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.deepBlue,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeDerichebourg = ThemeDerichebourg;
var ThemeSbaa = {
    name: 'sbaa',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    contracts: {
        primary: Theme_1.colors.SBAA_lightBlue,
        activeIcon: Theme_1.colors.purple
    },
    consumptions: {
        bars: Theme_1.colors.SBAA_green
    },
    colors: {
        primary: Theme_1.colors.SBAA_lightBlue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.SBAA_lightBlue,
        primaryDark: Theme_1.colors.SBAA_blue,
        secondary: Theme_1.colors.SBAA_lightGreen,
        secondaryLight: Theme_1.colors.SBAA_lightGreen
    }
};
exports.ThemeSbaa = ThemeSbaa;
var ThemeGmva = {
    name: 'gmva',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    contracts: {
        primary: Theme_1.colors.GMVA_deep_green,
        activeIcon: Theme_1.colors.purple
    },
    consumptions: {
        bars: Theme_1.colors.GMVA_yellow_green
    },
    colors: {
        primary: Theme_1.colors.GMVA_deep_green,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.GMVA_deep_green,
        primaryDark: Theme_1.colors.GMVA_dark_green,
        secondary: Theme_1.colors.GMVA_light_green,
        secondaryLight: Theme_1.colors.GMVA_light_green
    }
};
var ThemeSiaepQuestembert = {
    name: 'siaep-questembert',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    contracts: {
        primary: Theme_1.colors.SIAEP_lightBlue,
        activeIcon: Theme_1.colors.purple
    },
    consumptions: {
        bars: Theme_1.colors.SIAEP_yellow
    },
    colors: {
        primary: Theme_1.colors.SIAEP_lightBlue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.SIAEP_lightBlue,
        primaryDark: Theme_1.colors.SIAEP_blue,
        secondary: Theme_1.colors.SIAEP_green,
        secondaryLight: Theme_1.colors.SIAEP_greenLight
    }
};
exports.ThemeSiaepQuestembert = ThemeSiaepQuestembert;
var ThemeSepra = {
    name: 'sepra',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    contracts: {
        primary: Theme_1.colors.SEPRA_blue,
        activeIcon: Theme_1.colors.orange
    },
    consumptions: {
        bars: Theme_1.colors.SEPRA_lightBlue
    },
    colors: {
        primary: Theme_1.colors.SEPRA_blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.SEPRA_blue,
        primaryDark: Theme_1.colors.SEPRA_DeepBlue,
        secondary: Theme_1.colors.SEPRA_green,
        secondaryLight: Theme_1.colors.SEPRA_greenLight
    }
};
exports.ThemeSepra = ThemeSepra;
var ThemeSieccao = {
    name: 'sieccao',
    logoIconColor: Theme_1.colors.white,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.blue,
    separator: Theme_1.colors.white,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.white,
        activeColor: Theme_1.colors.white
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.white
    },
    contracts: {
        primary: Theme_1.colors.SIECCAO_blue,
        activeIcon: Theme_1.colors.purple
    },
    consumptions: {
        bars: Theme_1.colors.SIECCAO_lightBlue
    },
    colors: {
        primary: Theme_1.colors.SIECCAO_blue,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.SIECCAO_lightBlue,
        primaryAccent: Theme_1.colors.SIECCAO_lightBlue,
        primaryDark: Theme_1.colors.SIECCAO_DeepBlue,
        secondary: Theme_1.colors.SIECCAO_green,
        secondaryLight: Theme_1.colors.SIECCAO_greenLight
    }
};
exports.ThemeSieccao = ThemeSieccao;
var ThemeIleo = {
    name: 'ileo',
    logoIconColor: Theme_1.colors.ILEO_red,
    logoIconActiveColor: Theme_1.colors.white,
    logOutIconColor: Theme_1.colors.ILEO_red,
    separator: Theme_1.colors.ILEO_red,
    menuBackground: Theme_1.colors.white,
    field: {
        fieldLabelColor: Theme_1.colors.grey,
        errorColor: Theme_1.colors.error,
        infoColor: Theme_1.colors.greyBlue,
        hoverColor: Theme_1.colors.ILEO_red,
        activeColor: Theme_1.colors.ILEO_red
    },
    card: {
        backgroundColor: Theme_1.colors.white
    },
    texts: {
        fontFamilyRegular: Theme_1.fonts.montserratRegularName,
        fontFamilyMedium: Theme_1.fonts.montserratMediumName,
        fontFamilyItalic: Theme_1.fonts.montserratItalicName,
        fontFamilySemiBold: Theme_1.fonts.montserratSemiBoldName,
        fontFamilyBold: Theme_1.fonts.montserratBoldName,
        fontFamilyBlack: Theme_1.fonts.montserratBlackName,
        darkColor: Theme_1.colors.black,
        lightColor: Theme_1.colors.white,
        menuText: Theme_1.colors.black
    },
    colors: {
        primary: Theme_1.colors.ILEO_red,
        primaryLight: Theme_1.colors.lightBlue,
        primaryLightThin: Theme_1.colors.lightThinBlue,
        primaryAccent: Theme_1.colors.greyBlue,
        primaryDark: Theme_1.colors.ILEO_red,
        secondary: Theme_1.colors.green,
        secondaryLight: Theme_1.colors.greenLight
    }
};
exports.ThemeIleo = ThemeIleo;
function getTheme(theme) {
    switch (theme) {
        case 'saur':
            return ThemeSaur;
        case 'eau-de-garonne':
            return ThemeEau2Garonne;
        case 'atlantic-eau':
            return ThemeAtlanticeau;
        case 'sem':
            return ThemeSem;
        case 'saur-martinique':
            return ThemeMartinique;
        case 'vilivia':
            return ThemeVilivia;
        case 'saur-gpeau':
            return ThemeGpeau;
        case 'sepig':
            return ThemeSepig;
        case 'se3r':
            return ThemeSe3r;
        case 'accm':
            return ThemeAccm;
        case 'cer':
            return ThemeCer;
        case 'cise-reunion':
            return ThemeCiseReunion;
        case 'cgsp':
            return ThemeCgsp;
        case 'saur-guadeloupe':
            return ThemeSaurGuadeloupe;
        case 'grand-lac':
            return ThemeGrandLac;
        case 'saint-affo':
            return ThemeSaintAffo;
        case 'saint-martin':
            return ThemeSaintMartin;
        case 'sateg':
            return ThemeSateg;
        case 'sudeau':
            return ThemeSudeau;
        case 'saur-eau-du-morbihan':
            return ThemeEauDuMorbihan;
        case 'eaux-saumur-val-de-loire':
            return ThemeEauxSaumurValDeLoire;
        case 'saur-derichebourg-aoi':
            return ThemeDerichebourg;
        case 'siaep-questembert':
            return ThemeSiaepQuestembert;
        case 'sepra':
            return ThemeSepra;
        case 'sieccao':
            return ThemeSieccao;
        case 'ileo':
            return ThemeIleo;
        case 'sbaa':
            return ThemeSbaa;
        case 'gmva':
            return ThemeGmva;
        default:
            return ThemeSaur;
    }
}
exports.getTheme = getTheme;
